import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DistictiveFactorsPressuresSidebar/DistictiveFactorsPressuresSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DistinctiveFactorsChartRadar/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DistinctiveFactorsSidebar/DistinctiveFactorsSidebar.tsx");
